export const CREATE_NEW_INSURED_SELECTION_KEY = 'create_new_insured';
